export default __webpack_public_path__ + "static/media/Edit.0387574b.svg";